// import CentriDiEccellenzaAccordion from '@components/centri-di-eccellenza/accordions';
import CentriDiEccellenzaHead from '@components/centri-di-eccellenza/head';
import CentriDiEccellenzaImages from '@components/centri-di-eccellenza/image-bar';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { PageHead } from '../../components/common/head/page-head';
import { Navbar } from '../../components/common/navbar/navbar';
import styles from './index.module.css';
import { useSiteData } from '../../context/site-data-context';

export default function CentriDiEccellenza() {
  const { serviceCategories, technologyCategories } = useSiteData();
  const intl = useIntl();

  return (
    <div className="snf-lx-pages-innovation-center-index" style={{ display: 'contents' }}>
      <>
        <PageHead
          title={intl.formatMessage({
            defaultMessage: 'Sistemi Informativi S.r.l. - An IBM company - Centri di eccellenza',
            description: 'Centri di eccellenza - Page title'
          })}
          description={intl.formatMessage({
            defaultMessage: 'Sistemi Informativi S.r.l. - Centri di eccellenza',
            description: 'Centri di eccellenza - Page description'
          })}
        />
        <Navbar
          navCssClasses={classNames(styles.navbarBackground, 'position-fixed')}
          navLinkCssClasses={styles.navItem}
          serviceCategories={serviceCategories}
          technologyCategories={technologyCategories}
        />
        <main role="main" className="mt-5">
          <div className="container-fluid m-0 p-0">
            <CentriDiEccellenzaHead />
            <CentriDiEccellenzaImages />

            <div className="row justify-content-end m-0 my-4">
              <div className="col-auto ">
                <img className="img" alt="Logo regione" src="/images/logo-regione.png" />
              </div>
            </div>
            {/* <CentriDiEccellenzaAccordion /> */}
          </div>
        </main>
      </>
    </div>
  );
}
